<template>
  <Modal
    :closable="false"
    :wrap-class-name="wrapperClasses"
    :visible="isIncomingCall"
    :title="null"
    :animated="false"
    :footer="null"
    :body-style="{ width: '392px', height: '253px', padding: 0 }"
    :width="392"
    :mask="false"
    @cancel="ignoreCall"
  >
    <div class="caller-avatar">
      <Avatar
        shape="square"
        style="border-radius: 16px"
        :size="64"
        :src="avatarUrl"
      />
    </div>
    <div class="calling-info">{{ $t('home.InvitesCommunicateCollaborate').replace('XX', inviterName) }}…</div>
    <div class="calling-btns">
      <Button class="reject-btn" @click="rejectCallManual"
        ><SvgIcon icon-class="video-off" class="mr-9" />{{$t('home.HangUp')}}</Button
      >
      <Button class="answer-btn" @click="handleAnswer"
        ><SvgIcon icon-class="video" class="mr-9" />{{$t('home.Answer')}}</Button
      >
    </div>
  </Modal>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { Modal, Avatar, Button } from 'ant-design-vue'
import { getAudio, startTabBlink, stopTabBlink } from '@/utils/single'

import SvgIcon from '@/components/behavior/svg-icon/index.vue'
import defAvatar from '@/assets/def-avatar.png'
import { isEdgeBrowser } from '@/utils/ua'

let inviterNameCache
// 被呼叫的面板
export default {
  name: 'CallingPanel',
  components: {
    Modal,
    Avatar,
    Button,
    SvgIcon
  },
  data() {
    return {
      defAvatar,
      isAnswer: false
    }
  },
  computed: {
    ...mapGetters(['isIncomingCall']),
    inviterName() {
      if (this.$store.state.currentSession?.inviterName) {
        inviterNameCache = this.$store.state.currentSession?.inviterName
      }
      return inviterNameCache
    },
    avatarUrl () {
      let inviterAvatar = this.$store.state.currentSession?.inviterAvatar

      if (inviterAvatar && !inviterAvatar.indexOf('/')) {
        inviterAvatar = '/' + inviterAvatar
      }

      return inviterAvatar || this.defAvatar
    },
    wrapperClasses() {
      return isEdgeBrowser ? 'edge-modal-wraper calling-panel-modal-wraper' : 'calling-panel-modal-wraper'
    }
  },
  methods: {
    ...mapActions(['acceptCall', 'rejectCallManual', 'ignoreCall']),
    async handleAnswer() {
      this.isAnswer = true
      const microphoneClose = await this.$store.dispatch('getMetuTypeSetting')
      this.acceptCall({ microphoneClose })
    }
  },
  watch: {
    isIncomingCall(val) {
      const audio = getAudio()
      if (val) {
        startTabBlink(`${this.$t('home.InvitesCommunicateCollaborate').replace('XX', this.inviterName)}…`)
        audio.loop = true
        audio.src = './audio/call_ringtone.mp3'
      } else {
        stopTabBlink()
        audio.loop = false
        audio.src = this.isAnswer ? '' : './audio/call_end.mp3'
      }
      this.isAnswer = false
    }
  },
  beforeDestroy() {
    stopTabBlink()
  }
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
::v-deep .calling-panel-modal-wraper {
  pointer-events: none;

  .ant-modal {
    position: absolute;
    top: auto;
    bottom: 24px;
    right: 32px;
    cursor: pointer;

    padding-bottom: 0;
    & > .ant-modal-content {
      border-radius: 16px;
      box-shadow: 0px 5px 30px 0px rgba(89, 132, 219, 0.08);
      border: 1px solid #edeff2;
      overflow: hidden;
    }

    & .ant-modal-body {
      &::before {
        content: " ";
        display: table;
      }
    }
  }

  &.edge-modal-wraper {
    .ant-modal {
      bottom: 132px;
    }
  }
}

.caller-avatar {
  width: 64px;
  height: 64px;
  margin: 40px auto 24px;
}

.calling-info {
  .regular-font(14);
  text-align: center;
  color: #000;
  line-height: 20px;
}

.calling-btns {
  position: absolute;
  bottom: 40px;
  display: flex;
  justify-content: space-between;
  width: 280px;
  margin-left: 50%;
  transform: translateX(-50%);
  & > .reject-btn,
  & > .answer-btn {
    .medium-font(16);
    display: block;
    width: 128px;
    height: 41px;

    border-radius: 20px;
    color: #fff;
    border-color: transparent;
  }
  & > .reject-btn {
    background: #e84a4b;
    box-shadow: 0px 6px 10px 0px rgba(255, 193, 193, 0.5);

    &:hover {
      background: #cf4243;
    }
  }
  & > .answer-btn {
    background: #60ce64;
    box-shadow: 0px 5px 10px 0px rgba(96, 206, 100, 0.5);

    &:hover {
      background: #25b039;
    }
  }
}
</style>
